// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "nav[data-v-59050815]{--index:0;--base:calc(320px - 2rem)}.flex-basis-full[data-v-59050815]{flex-basis:var(--base)}.move[data-v-59050815]{transform:translateX(calc(var(--index)*var(--base)*-1))}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
